import angular = require("angular");
import TPL = require("templates");
import {Config} from "../../config";
import {ConfirmController} from "../../modals/confirm";
import {SuccessController} from "../../modals/success";
import {LoginController} from "../../modals/login";

export class Link {

  id: number;
  label: string;
  linkClass: string;
  linkSection: string | string[];
  linkUrl: string;
  target: string;
  callback: (data?) => void;
  subLinkList: Link[];

  isActive(currentLocation) {
    if (!this.linkSection || !currentLocation) {
      return false;
    }

    if (typeof this.linkSection === 'string') {
      return currentLocation.indexOf(this.linkSection) >= 0;
    }

    var active = false;

    angular.forEach(this.linkSection, (value) => {
      if (currentLocation.indexOf(value) >= 0) {
        active = true;
      }
    });

    return active;
  }


  static idGen = 0;
  static createDummyLink(): Link {
    var result = new Link();
    result.id = Link.idGen++;
    result.label = "Link " + result.id.toString();
    result.callback = () => {alert("clicked");};
    return result;
  }

  static buildLink(label: string, linkUrl: string, target: string, callback: (data?) => void, linkClass?: string, linkSection?: string | string[], subLinkList?: Link[]) {
    var result = new Link();
    result.id = Link.idGen++;
    result.label = label;
    result.callback = callback;
    result.linkClass = linkClass;
    result.linkSection = linkSection;
    result.linkUrl = linkUrl;
    result.target = target;
    return result;
  }
}


export class LinkList extends Array<Link> {

  static buildLinkList(): LinkList {
    var result = new LinkList();

    for (var i = 0; i < 5; i++) {
      result.push(Link.createDummyLink());
    }

    return result;
  }

  static buildFooterLinkList(session, location, anchorScroll, modal): LinkList {
    var result = new LinkList();
    result.push(Link.buildLink("LANDING.POWERED", "", Config.wp_onetable, () => {
      location.url(Config.wp_onetable);
    }, "ot-link"));
    return result;
  }


  static buildHeaderLinkList(session, location, anchorScroll, modal, window, rootScope): LinkList {
    var result = new LinkList();

    /*var findEvent = Link.buildLink("LANDING.FIND_EVENT", "", "", (data) => {
      location.path(Config.home + "/" + data);
      location.replace();
    }, "ot-link", [Config.home, Config.events]);

    findEvent.subLinkList = new LinkList();

    angular.forEach(session.getAvailableCities(), (value) => {
      findEvent.subLinkList.push(Link.buildLink(value.label, "", "", null, null, value.url));
    });

    result.push(findEvent);*/

    result.push(Link.buildLink("LANDING.FIND_EVENT", "", Config.home, () => {
      location.url(Config.home);
    }, "ot-link"));

    result.push(Link.buildLink("LANDING.CREATE_DINNER", "", Config.home+"/"+Config.events, () => {
      location.url(Config.events);
    }, "ot-link"));

    result.push(Link.buildLink("LANDING.ABOUT", Config.wp_locations , "_blank", () => {
    //  window.open(Config.wp_home + "/about/","_blank");
    }, "ot-link"));

    return result;
  }

  static buildEventAnchorList(location, anchorScroll): LinkList {
    var result = new LinkList();

    var goTo = (hash) => {
      var old = location.hash();
      location.hash(hash);
      anchorScroll();
      //reset to old to keep any additional routing logic from kicking in
      location.hash(old);
    }

    var linkDetails = Link.buildLink("EVENT.DETAILS_ANCHOR", "", "", () => {
      goTo(linkDetails.linkSection);
    }, "ot-subheader-link", "details");

    var linkDishes = Link.buildLink("EVENT.DISHES_ANCHOR", "", "", () => {
      goTo(linkDishes.linkSection);
    }, "ot-subheader-link ot-dishes-link", "menu");

    var linkHost = Link.buildLink("EVENT.HOST_ANCHOR", "", "", () => {
      goTo(linkHost.linkSection);
    }, "ot-subheader-link", "host");

    result.push(linkDetails);
    result.push(linkDishes);
    result.push(linkHost);

    return result;
  }

  static becomeHostProcedure(session, modal, rootScope) {

    if (session.isNotLogging()) {

      var parent:any = {};
      parent.currentModal = LoginController.openLoginModal(modal, parent, rootScope, () => {
        LinkList.becomeHostProcedure(session, modal, rootScope);
      });
    } else {

      var rUSModal = ConfirmController.openRequestHostModal(modal,
        ()=>{ //submit
          /*
          session.requestHost().then(() => {
            rUSModal.dismiss();
            window.location.href = Config.wp_becameanhost;
          }, (error) => {
            rUSModal.dismiss();
            window.location.href = Config.wp_becameanhost;
          });
          rUSModal.dismiss();
          if (Config.isOnward) {
            window.location.href = Config.wp_onward_becameanhost;
          } else {
            window.location.href = Config.wp_becameanhost;
          }
          */
        },
        ()=> {//cancel
          rUSModal.dismiss();
        });
      }
  }

  constructor() {
    super();
  }
}


export class LinkListDirective {

  template;
  link;
  scope = {
    params: "=params"
  };

  constructor(session, $location, $anchorScroll, $modal, $window, $rootScope) {
    this.template = TPL.navigationDirectives.linkList;

    this.link = (scope, el, attrs) => {

        var linkList;
        var type = scope.params ? scope.params.type : "";

        switch(type) {
          case "header":
            linkList = LinkList.buildHeaderLinkList(session, $location, $anchorScroll, $modal, $window, $rootScope);
            break;
          case "eventAnchors":
            linkList = LinkList.buildEventAnchorList($location, $anchorScroll);
            break;
          default:
            linkList = LinkList.buildFooterLinkList(session, $location, $anchorScroll, $modal);
        }
        scope.vm = {
          linkList: linkList,
          session: session
        }
    }
  }

  static factory() {
    var tmp = (a, b, c, d, e, f) => new LinkListDirective(a, b, c, d, e, f);
    tmp.$inject = ["session", "$location", "$anchorScroll", "$uibModal", "$window", "$rootScope"];
    return tmp;
  }

}

export class LinkDirective {

  template = TPL.navigationDirectives.link;
  scope = {
    item: "=item"
  };
  link;


  constructor(location) {

    this.link = (scope, el, attrs) => {
        scope.computeLinkCss = () => {
          var s = scope.item.isActive(location.path()) ? "ot-active-link " : "";
          return s.concat(scope.item.linkClass);
        }
    }
  }

  static factory() {
    var tmp = (a) => new LinkDirective(a);
    tmp.$inject = ["$location"];
    return tmp;
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/navigation/link.ts
 **/